/** ISO 4217 codes supported for monetary amounts (UI + validation). */
export const FINANCE_CURRENCY_CODES = ['TRY', 'USD', 'EUR', 'GBP'];

/** @deprecated Use FINANCE_CURRENCY_CODES */
export const ASSET_FINANCE_CURRENCY_CODES = FINANCE_CURRENCY_CODES;

export const DEFAULT_FINANCE_CURRENCY = 'TRY';

/** @deprecated Use DEFAULT_FINANCE_CURRENCY */
export const DEFAULT_ASSET_FINANCE_CURRENCY = DEFAULT_FINANCE_CURRENCY;

/** Upper bound for monetary fields (avoids overflow / junk input). */
export const ASSET_FINANCE_AMOUNT_MAX = 1e14;
